import { win } from '../window.js';
export const convincely = win.convincely3 ??= { $apps: {}, cache: {} };
export const convincelyLegacy = win.convincely ??= {};
/** Export object to window and make it re-usable */
export function reusable(name, value, base) {
    if (base) {
        return ((convincely.$apps[base] ??= {})[name] ??= value);
    }
    return (convincely[name] ??= value);
}
export function addHook(name, callback) {
    return (convincely[name] ??= callback);
}
//# sourceMappingURL=convincely.js.map